var m = require('mithril');
var prop = require('mithril/stream');

var hoverableDropdownDiv = {
  oninit: function(vnode) {
    vnode.state.isDropdownOpen = prop(vnode.attrs.isOpen || false);
    vnode.state.toggleButtonId = vnode.attrs.menuId + '-toggle'; // Unique ID for the toggle button
    vnode.state.closeTimeout = null;

    vnode.state.cancelScheduledClose = function() {
      if (vnode.state.closeTimeout) {
        clearTimeout(vnode.state.closeTimeout);
        vnode.state.closeTimeout = null;
      }
    };

    vnode.state.keepDropdownOpen = function() {
      vnode.state.cancelScheduledClose();
      if (vnode.state.isDropdownOpen() && typeof vnode.attrs.onMouseOver === 'function') {
        vnode.attrs.onMouseOver();
      }
    };

    vnode.state.scheduleDropdownClose = function() {
      if (!vnode.state.isDropdownOpen()) {
        return;
      }
      vnode.state.cancelScheduledClose();
      vnode.state.closeTimeout = setTimeout(function() {
        vnode.state.closeTimeout = null;
        if (typeof vnode.attrs.onMouseOut === 'function') {
          vnode.attrs.onMouseOut();
        }
        m.redraw();
      }, 300);
    };

    vnode.state.positionHoverBridge = function(bridgeElement) {
      if (!bridgeElement) {
        return;
      }
      var ownerDocument = bridgeElement.ownerDocument || (typeof document !== 'undefined' ? document : null);
      var toggleButton = ownerDocument && ownerDocument.getElementById(vnode.state.toggleButtonId);
      var dropdown = ownerDocument && ownerDocument.getElementById(vnode.attrs.menuId);
      if (!toggleButton || !dropdown ||
        typeof toggleButton.getBoundingClientRect !== 'function' ||
        typeof dropdown.getBoundingClientRect !== 'function') {
        bridgeElement.style.display = 'none';
        return;
      }

      var toggleRect = toggleButton.getBoundingClientRect();
      var dropdownRect = dropdown.getBoundingClientRect();
      var bridgeWidth = toggleRect.left - dropdownRect.left;
      var bridgeHeight = dropdownRect.top - toggleRect.top;

      if (bridgeWidth <= 0 || bridgeHeight <= 0) {
        bridgeElement.style.display = 'none';
        return;
      }

      bridgeElement.style.display = 'block';
      bridgeElement.style.left = dropdownRect.left + 'px';
      bridgeElement.style.top = toggleRect.top + 'px';
      bridgeElement.style.width = bridgeWidth + 'px';
      bridgeElement.style.height = bridgeHeight + 'px';
    };

    vnode.state.handleOutsideTouch = function(e) {
      var touchedElement = e.target;
      var toggleButton = document.getElementById(vnode.state.toggleButtonId);
      var dropdown = document.getElementById(vnode.attrs.menuId);

      if (toggleButton && (toggleButton === touchedElement || toggleButton.contains(touchedElement))) {
        return;
      }

      if (dropdown && !dropdown.contains(touchedElement) && vnode.state.isDropdownOpen()) {
        vnode.state.isDropdownOpen(false);
        m.redraw();
      }
    };
  },
  oncreate: function(vnode) {
    if (typeof document !== 'undefined') {
      document.addEventListener('touchstart', vnode.state.handleOutsideTouch);
    }
  },
  onremove: function(vnode) {
    vnode.state.cancelScheduledClose();
    if (typeof document !== 'undefined') {
      document.removeEventListener('touchstart', vnode.state.handleOutsideTouch);
    }
  },
  view: function(vnode) {
    vnode.state.isDropdownOpen(vnode.attrs.isOpen);

    var toggleButtonStyles = vnode.state.isDropdownOpen() ? 'ba b--blue br2 ph1 flex items-center h2 bb-0 z-1' : 'ba b--blue br2 ph1 flex items-center h2 z-0';
    var dropdownStyles = vnode.state.isDropdownOpen() ? 'br2 ba pa2 bg-dark-gray absolute w-100 left-0 b--blue z-2' : 'br2 ba pa2 bg-dark-gray absolute w-100 left-0 z-0';
    var buttonTextStyles = vnode.state.isDropdownOpen() ? 'f4 mr2 mv1 blue' : 'f4 mr2 mv1';
    var arrowLabel = m('span.dib', {
      style: {
        width: 0,
        height: 0,
        borderLeft: '0.34rem solid transparent',
        borderRight: '0.34rem solid transparent',
        borderTop: '0.44rem solid #58abe2',
        verticalAlign: 'middle'
      }
    });

    return m(`div.f4${vnode.attrs.mainDivClass || ''}`, {
      onmouseenter: vnode.state.keepDropdownOpen,
      onmouseleave: vnode.state.scheduleDropdownClose
    }, [
      m('span', { class: toggleButtonStyles, id: vnode.state.toggleButtonId, onclick: function() {
        vnode.state.cancelScheduledClose();
        vnode.attrs.toggleDropdown(vnode.attrs.menuId);
      }}, [
        m('span', { class: buttonTextStyles }, vnode.attrs.menuTitle),
        arrowLabel,
      ]),
      vnode.state.isDropdownOpen() && m('div.hoverable-dropdown-hover-bridge', {
        'aria-hidden': 'true',
        style: {
          position: 'fixed',
          display: 'none',
          backgroundColor: 'transparent',
          pointerEvents: 'auto',
          zIndex: 998
        },
        oncreate: function(bridgeVnode) {
          vnode.state.positionHoverBridge(bridgeVnode.dom);
        },
        onupdate: function(bridgeVnode) {
          vnode.state.positionHoverBridge(bridgeVnode.dom);
        }
      }),
      vnode.state.isDropdownOpen() && m('div', { class: dropdownStyles, id: vnode.attrs.menuId, style: {
        backgroundColor: '#212121',
        zIndex: 999,
        minHeight: '16rem',
      }}, vnode.attrs.content)
    ])
  }
};

module.exports = hoverableDropdownDiv;
